import { render, staticRenderFns } from "./QuestionLayout.vue?vue&type=template&id=2ea86bb5&"
import script from "./QuestionLayout.vue?vue&type=script&lang=js&"
export * from "./QuestionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports